'use strict';

goog.provide("Ntry.Restore");

goog.require("Ntry.STATIC");

Ntry.Restore = function(restore) {
    restore = restore || {};
    this.shouldRestore = restore.shouldRestore;
    this.data = restore.data;
    this.origins = restore.origins;
};

Ntry.Restore.prototype.type =
    Ntry.STATIC.RESTORE;

